import React, { CSSProperties, FC, HTMLAttributes } from 'react'

import cn from 'classnames'

import classes from './position.module.scss'

interface CenteredProps extends HTMLAttributes<HTMLDivElement> {
  margin?: string
}

export const Centered: FC<CenteredProps> = ({
  margin,
  className,
  style,
  children,
  ...rest
}) => (
  <div
    className={cn(classes.centered, className)}
    style={{ ...style, '--centered-margin': margin } as CSSProperties}
    {...rest}
  >
    {children}
  </div>
)
